import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "space-y-3" }
const _hoisted_2 = { class: "inline-block rounded-lg border border-gray-200 bg-white p-2" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "h-36 w-36 animate-pulse rounded bg-gray-100",
  "aria-hidden": "true"
}
const _hoisted_5 = { class: "flex flex-wrap gap-2" }
const _hoisted_6 = {
  key: 0,
  class: "text-sm text-gray-500"
}

import { ArrowDownTrayIcon, ClipboardDocumentIcon } from '@heroicons/vue/20/solid'
import { ref, watch } from 'vue'

import NeueButton from '@/components/neue/NeueButton.vue'
import { useToast } from '@/composables/useToast'
import { canCopyImages, copyImageToClipboard, downloadBlob, qrCodeDataUrl, qrCodePngBlob } from '@/helpers/qrCode'


export default {
  __name: 'LeadCaptureQrCode',
  props: {
  url: { type: String, required: true },
  enabled: { type: Boolean, default: false }
},
  setup(__props) {

const props = __props

const { showToast } = useToast()
const canCopy = canCopyImages()
const dataUrl = ref('')

watch(
  () => props.url,
  url => {
    dataUrl.value = ''
    qrCodeDataUrl(url)
      .then(value => {
        if (url === props.url) dataUrl.value = value
      })
      .catch(() => {
        if (url === props.url) dataUrl.value = ''
      })
  },
  { immediate: true }
)

const copyImage = () =>
  copyImageToClipboard(qrCodePngBlob(props.url))
    .then(() => showToast('QR code copied'))
    .catch(() => showToast("Couldn't copy - use Download instead", { type: 'error' }))

const download = () =>
  qrCodePngBlob(props.url)
    .then(blob => downloadBlob(blob, 'lead-capture-qr.png'))
    .catch(() => showToast("Couldn't download the QR code - please try again", { type: 'error' }))

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (dataUrl.value)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: dataUrl.value,
            alt: "QR code for your lead capture page",
            class: "h-36 w-36"
          }, null, 8, _hoisted_3))
        : (_openBlock(), _createElementBlock("div", _hoisted_4))
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_unref(canCopy))
        ? (_openBlock(), _createBlock(NeueButton, {
            key: 0,
            type: "secondary",
            size: "sm",
            onClick: copyImage
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ClipboardDocumentIcon), {
                class: "mr-1.5 h-4 w-4",
                "aria-hidden": "true"
              }),
              _cache[0] || (_cache[0] = _createTextVNode(" Copy image ", -1))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(NeueButton, {
        type: "secondary",
        size: "sm",
        onClick: download
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ArrowDownTrayIcon), {
            class: "mr-1.5 h-4 w-4",
            "aria-hidden": "true"
          }),
          _cache[1] || (_cache[1] = _createTextVNode(" Download PNG ", -1))
        ]),
        _: 1
      })
    ]),
    (!__props.enabled)
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, " Your page is off, so scans will show 'This page isn't available'. "))
      : _createCommentVNode("", true)
  ]))
}
}

}